const NETWORK_ERROR_RE =
  /failed to fetch|load failed|networkerror|network request failed|could not connect|failed to load|access control/i;

const toErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  return null;
};

const asUserFacingMessage = (message) => {
  if (message && NETWORK_ERROR_RE.test(message)) {
    return 'Could not connect to the server. Please try again.';
  }
  return message;
};

export const processApiError = (error) => {
  const directMessage = asUserFacingMessage(toErrorMessage(error));
  if (directMessage) {
    return directMessage;
  }

  if (error?.response?.data) {
    const data = error.response.data;
    
    if (data.detail) {
      if (Array.isArray(data.detail)) {
        const errorMessages = data.detail.map(err => {
          if (typeof err === 'object' && err.msg) {
            return err.msg;
          } else if (typeof err === 'string') {
            return err;
          }
          return JSON.stringify(err);
        });
        return asUserFacingMessage(errorMessages.join('; ')) || errorMessages.join('; ');
      } else if (typeof data.detail === 'string') {
        if (data.detail.includes('TAB_OUT_OF_BOUNDS')) {
          return 'Wrong document sizing. A4 format accepted only';
        }
        return asUserFacingMessage(data.detail) || data.detail;
      }
      return JSON.stringify(data.detail);
    }
    
    if (data.message) {
      return asUserFacingMessage(data.message) || data.message;
    }
    
    if (typeof data === 'string') {
      return asUserFacingMessage(data) || data;
    }
  }

  return 'An unexpected error occurred';
};
